import logo from 'assets/logo/hoje logo white.svg';
const LogoPage = () => {
  return (
    <div className="h-screen w-screen relative flex flex-col items-center justify-center bg-[#22a68f] ">
      <img src={logo} alt="logo" className="px-16" />
    </div>
  );
};

export default LogoPage;
